/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_plus_circle': {
    width: 25,
    height: 26,
    viewBox: '0 0 25 26',
    data: '<path pid="0" d="M12.5 6v6.507m0 0V19m0-6.493H19m-6.5 0H6m18.5 0c.047 6.627-5.287 12.038-11.914 12.084C5.958 24.638.548 19.304.5 12.676.455 6.05 5.79.64 12.416.592 19.044.545 24.454 5.88 24.501 12.507z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_plus_circle.js